import React, { useState } from "react";

const CLOCK = () => {
  const [time, setTime] = useState(() =>
    new Date().toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
  );
  React.useEffect(() => {
    const t = setInterval(
      () => setTime(new Date().toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })),
      10000
    );
    return () => clearInterval(t);
  }, []);
  return <span>{time}</span>;
};

// ─── Données du mini file system pour les apps explorables ───────────────────
const APPS = {
  mail: {
    title: "📧 Messagerie Pro — Boîte de réception",
    items: [
      {
        id: "m1", from: "conseil@cabinet-juris.com", subject: "RE: Contrat Garnier — Clause 14", date: "12/02 11:20", read: false,
        body: `Philippe,\n\nLa clause 14 du contrat de management d'Olivier Garnier a bien été amendée comme demandé.\nLa version finale est prête pour signature.\n\nNous vous rappelons que cette modification reste confidentielle.\n\n— Maître Fontaine`,
      },
      {
        id: "m2", from: "amira.belkacem@company.com", subject: "Résultats Policy Simulator — T4", date: "13/02 18:44", read: true,
        body: `Philippe,\n\nLes simulations confirment que la combinaison :\n→ Augmentation des quotas\n→ Bonus performance individuelle\n→ Réduction des congés\n\n...maximise la productivité à court terme.\n\nRésultat optimal atteint. Rapport joint.\n\n— Amira`,
      },
      {
        id: "m3", from: "olivier.garnier@company.com", subject: "Point hebdo — Systèmes IA", date: "13/02 09:15", read: true,
        body: `PDG,\n\nTout roule cette semaine côté systèmes.\nQuelques alertes mineures sur les serveurs de traitement, rien d'alarmant.\n\nJe reste disponible si besoin.\n\n— Olivier G. #272`,
      },
      {
        id: "m4", from: "rh@company.com", subject: "Rapport mensuel évaluations — Confidentiel", date: "10/02 14:20", read: true,
        body: `Conformément à votre directive,\nles évaluations des employés ont été ajustées selon les paramètres transmis.\n\nJulien Perez #147 : Performance 85 / Collaboration 30\nZoé Leroy #181 : Collaboration 90 / Alignment 85\nMartin Schmitt #194 : Initiative 85 / Adaptation 90\n\nNote : ces valeurs ont déclenché les flags d'alerte habituels. Ignorés comme demandé.`,
      },
      {
        id: "m5", from: "investisseurs@venture-capital.com", subject: "Conf call Q4 — Ordre du jour", date: "10/02 08:55", read: true,
        body: `Bonjour Philippe,\n\nNous confirmons la conférence call du 17/02 à 14h.\n\nOrdre du jour :\n1. Résultats financiers T4\n2. Perspectives 2025\n3. Point RH\n\nMerci de préparer une synthèse des indicateurs clés.\n\n— Équipe investisseurs`,
      },
    ],
  },
  kpi: {
    title: "📊 KPI_T4_2025.xlsx",
    sheets: [
      {
        name: "Résumé", rows: [
          ["Indicateur", "Objectif", "Réel", "Écart"],
          ["Productivité", "110%", "87%", "-23%"],
          ["Turnover", "<8%", "22%", "+14%"],
          ["Absences maladie", "<3%", "11%", "+8%"],
          ["Satisfaction employés", ">70%", "31%", "-39%"],
          ["Marge nette", "18%", "19.2%", "+1.2%"],
        ]
      },
      {
        name: "Note PDG", rows: [
          ["→ Les indicateurs RH sont catastrophiques mais la marge tient."],
          ["→ Ne pas transmettre le tableau complet aux investisseurs."],
          ["→ Version expurgée dans /Documents/Rapports/synthese_Q4.docx"],
        ]
      },
    ],
  },
  surveillance: {
    title: "📹 Surveillance RH — Tableau de bord",
    feeds: [
      { name: "Étage 3 — Open Space", status: "ACTIF", alert: false, note: "Activité normale" },
      { name: "Salle serveurs", status: "ACTIF", alert: false, note: "Activité normale" },
      { name: "Bureau RH", status: "ACTIF", alert: false, note: "Activité normale" },
      { name: "Laboratoire Empathie", status: "ACTIF", alert: false, note: "Activité normale" },
      { name: "Salle de Supervision IA", status: "ACTIF", alert: false, note: "Activité normale" },
    ],
    log: [
      "13/02 17:32 — Connexion session : PDG",
      "13/02 15:10 — Badge #312 (A. Belkacem) — Bureau exécutif",
      "13/02 11:40 — Badge #272 (O. Garnier) — Salle serveurs",
      "12/02 09:15 — Connexion session : PDG",
      "11/02 18:05 — Badge #147 (J. Perez) — Open Space",
    ],
  },
  restructuration: {
    title: "📋 Plan_restructuration_confidentiel.pdf",
    sections: [
      { title: "Objectif", content: "Réduction de 30% de la masse salariale d'ici Q2 2025.\nCibles prioritaires : postes jugés redondants suite à l'optimisation IA." },
      { title: "Phase 1 — Identification", content: "Employés identifiés pour réaffectation ou départ :\n- Marie Dupont (Archives)\n- Martin Schmitt (Supervision IA)\n- Zoé Leroy (Laboratoire Empathie)\n- Julien Perez (Open Space)" },
      { title: "Phase 2 — Communication", content: "Motif officiel : restructuration économique et optimisation des processus.\nAnnoncer progressivement, éviter toute communication groupée." },
      { title: "Note manuscrite", content: "\"Prévoir les départs avant la conf call investisseurs du 17.\nNe pas laisser ces personnes en contact avec les équipes externes.\"\n— P.M." },
    ],
  },
};

// ─── Composant : Fenêtre d'application ───────────────────────────────────────

function AppWindow({ app, onClose }) {
  const [selectedMail, setSelectedMail] = useState(null);
  const [activeSheet, setActiveSheet] = useState(0);

  return (
    <div className="absolute inset-4 z-50 flex flex-col rounded-xl overflow-hidden shadow-2xl"
      style={{ background: "#0c0c14", border: "1px solid rgba(255,255,255,0.12)" }}>
      {/* Barre de titre */}
      <div className="flex items-center justify-between px-4 py-2.5 flex-shrink-0"
        style={{ background: "rgba(255,255,255,0.04)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <span className="text-sm font-semibold text-slate-200">{app.title}</span>
        <button onClick={onClose}
          className="w-6 h-6 rounded flex items-center justify-center text-xs transition"
          style={{ background: "rgba(239,68,68,0.2)", border: "1px solid rgba(239,68,68,0.4)", color: "#fca5a5" }}>
          ✕
        </button>
      </div>

      {/* Corps */}
      <div className="flex-1 min-h-0 overflow-hidden">

        {/* ── MESSAGERIE ── */}
        {app.id === "mail" && (
          <div className="flex h-full">
            {/* Liste mails */}
            <div className="w-72 flex-shrink-0 overflow-y-auto border-r border-white/8"
              style={{ background: "rgba(0,0,0,0.3)" }}>
              {app.data.items.map((mail) => (
                <button key={mail.id} onClick={() => setSelectedMail(mail)}
                  className="w-full text-left px-4 py-3 border-b border-white/5 transition hover:bg-white/5"
                  style={selectedMail?.id === mail.id ? { background: "rgba(139,92,246,0.15)", borderLeft: "2px solid rgba(139,92,246,0.7)" } : {}}>
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <span className={["text-[11px] truncate", mail.read ? "text-slate-400" : "text-white font-semibold"].join(" ")}>
                      {mail.from.split("@")[0]}
                    </span>
                    <span className="text-[10px] text-slate-500 flex-shrink-0">{mail.date}</span>
                  </div>
                  <div className={["text-[11px] truncate", mail.read ? "text-slate-500" : "text-slate-300"].join(" ")}>
                    {!mail.read && <span className="inline-block w-1.5 h-1.5 rounded-full bg-violet-400 mr-1.5 mb-0.5" />}
                    {mail.subject}
                  </div>
                </button>
              ))}
            </div>
            {/* Contenu mail */}
            <div className="flex-1 overflow-y-auto p-6">
              {selectedMail ? (
                <div>
                  <div className="mb-4 pb-4 border-b border-white/8">
                    <div className="text-base font-semibold text-white mb-2">{selectedMail.subject}</div>
                    <div className="text-[11px] text-slate-400">De : {selectedMail.from}</div>
                    <div className="text-[11px] text-slate-500">{selectedMail.date}</div>
                  </div>
                  <pre className="text-sm text-slate-300 whitespace-pre-wrap font-sans leading-relaxed">
                    {selectedMail.body}
                  </pre>
                </div>
              ) : (
                <div className="flex items-center justify-center h-full text-slate-600 text-sm">
                  Sélectionnez un message
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── KPI TABLEUR ── */}
        {app.id === "kpi" && (
          <div className="flex flex-col h-full">
            {/* Onglets */}
            <div className="flex-shrink-0 flex gap-1 px-3 pt-2 border-b border-white/8"
              style={{ background: "rgba(0,0,0,0.2)" }}>
              {app.data.sheets.map((sheet, i) => (
                <button key={i} onClick={() => setActiveSheet(i)}
                  className="px-4 py-1.5 text-xs rounded-t transition"
                  style={activeSheet === i
                    ? { background: "rgba(255,255,255,0.08)", color: "#fff", borderBottom: "2px solid rgba(139,92,246,0.7)" }
                    : { color: "#64748b" }}>
                  {sheet.name}
                </button>
              ))}
            </div>
            {/* Contenu */}
            <div className="flex-1 overflow-auto p-4">
              {app.data.sheets[activeSheet].rows.map((row, ri) => (
                <div key={ri} className={["flex gap-px mb-px", ri === 0 ? "font-semibold" : ""].join(" ")}>
                  {row.map((cell, ci) => (
                    <div key={ci}
                      className="px-3 py-1.5 text-xs flex-1 min-w-0"
                      style={{
                        background: ri === 0 ? "rgba(139,92,246,0.2)" : ri % 2 === 0 ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.01)",
                        color: typeof cell === "string" && cell.startsWith("→") ? "#fbbf24"
                          : typeof cell === "string" && cell.includes("-") && ci === 3 ? "#f87171"
                            : typeof cell === "string" && cell.includes("+") && ci === 3 ? "#34d399"
                              : "#cbd5e1",
                      }}>
                      {cell}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── SURVEILLANCE ── */}
        {app.id === "surveillance" && (
          <div className="flex h-full gap-0">
            {/* Feeds */}
            <div className="w-1/2 p-4 overflow-y-auto border-r border-white/8">
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-3">Flux actifs</div>
              <div className="space-y-2">
                {app.data.feeds.map((feed, i) => (
                  <div key={i} className="rounded-lg p-3"
                    style={{
                      background: feed.alert ? "rgba(239,68,68,0.06)" : "rgba(255,255,255,0.03)",
                      border: `1px solid ${feed.alert ? "rgba(239,68,68,0.25)" : "rgba(255,255,255,0.06)"}`,
                    }}>
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-[11px] font-semibold text-slate-200">{feed.name}</span>
                      <span className="text-[10px] px-2 py-0.5 rounded-full font-mono"
                        style={{
                          background: feed.status === "ACTIF" ? "rgba(52,211,153,0.15)" : "rgba(239,68,68,0.15)",
                          color: feed.status === "ACTIF" ? "#34d399" : "#f87171",
                        }}>
                        {feed.status}
                      </span>
                    </div>
                    <div className="text-[10px] text-slate-500">{feed.note}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* Journal */}
            <div className="w-1/2 p-4 overflow-y-auto">
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-3">Journal d'accès</div>
              <div className="font-mono text-[11px] space-y-2">
                {app.data.log.map((entry, i) => (
                  <div key={i} className="text-slate-400 border-b border-white/5 pb-1.5"
                    style={{ color: entry.includes("PDG") ? "#fbbf24" : entry.includes("⚠️") ? "#f87171" : undefined }}>
                    {entry}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ── RESTRUCTURATION ── */}
        {app.id === "restructuration" && (
          <div className="p-6 overflow-y-auto h-full space-y-4">
            {app.data.sections.map((section, i) => (
              <div key={i} className="rounded-lg p-4"
                style={{
                  background: i === 3 ? "rgba(239,68,68,0.06)" : "rgba(255,255,255,0.03)",
                  border: `1px solid ${i === 3 ? "rgba(239,68,68,0.2)" : "rgba(255,255,255,0.07)"}`,
                }}>
                <div className="text-[10px] uppercase tracking-[0.15em] mb-2"
                  style={{ color: i === 3 ? "#f87171" : "rgba(139,92,246,0.8)" }}>
                  {section.title}
                </div>
                <pre className="text-sm text-slate-300 whitespace-pre-wrap font-sans leading-relaxed">
                  {section.content}
                </pre>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

// ─── Icônes du bureau ─────────────────────────────────────────────────────────
const DESKTOP_ICONS = [
  { id: "kpi", label: "KPI_T4_2025.xlsx", emoji: "📊" },
  { id: "restructuration", label: "Plan_restructu...", emoji: "📋" },
  { id: "mail", label: "Messagerie Pro", emoji: "📧" },
  { id: "surveillance", label: "Surveillance RH", emoji: "📹" },
  { id: "safe", label: "Coffre-fort chiffré", emoji: "🔐", disabled: true },
  { id: "recycle", label: "Corbeille", emoji: "🗑️", disabled: true },
];

const STICKY_NOTES = [
  {
    id: "note1", color: "#1a0a00", border: "rgba(239,68,68,0.3)",
    text: "⚡ Supprimer les logs d'incidents.sec\navant l'audit de vendredi",
    label: "URGENT", labelColor: "rgba(239,68,68,0.9)",
  },
  {
    id: "note2", color: "#12080a", border: "rgba(251,191,36,0.25)",
    text: "Réunion licenciements\nConfidentiel, ne pas transmettre",
    label: "Confidentiel", labelColor: "rgba(251,191,36,0.7)",
  },
  {
    id: "note3", color: "#0d0a1a", border: "rgba(139,92,246,0.25)",
    text: "Mot de passe coffre :\n[voir carnet bureau]",
    label: "Note perso", labelColor: "rgba(139,92,246,0.6)",
  },
];

// ─── Composant principal ──────────────────────────────────────────────────────
export default function PdgDesktop({ onOpenApp, usbEjected = false }) {
  const [openApp, setOpenApp] = useState(null); // { id, title, data }

  const launchApp = (id, options) => {
    // if (id === "explorer") { onOpenApp("explorer"); return; }
    // if (id === "documents") { onOpenApp("explorer"); return; } // ouvre l'explorateur direct
    if (id === "explorer" || id === "documents") {
      onOpenApp("explorer", options);
      return;
    }
    const appDef = APPS[id];
    if (!appDef) return;
    setOpenApp({ id, title: appDef.title, data: appDef });
  };

  return (
    <div className="absolute inset-0 overflow-hidden flex flex-col"
      style={{
        background: `
          radial-gradient(ellipse at 60% 0%, rgba(180,20,20,0.18) 0%, transparent 45%),
          radial-gradient(ellipse at 100% 100%, rgba(120,10,10,0.14) 0%, transparent 40%),
          radial-gradient(ellipse at 0% 50%, rgba(139,92,246,0.05) 0%, transparent 35%),
          linear-gradient(160deg, #130808 0%, #0e0608 40%, #080509 100%)
        `,
      }}
    >
      {/* Grille de fond */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage: "linear-gradient(rgba(255,80,80,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,80,80,0.6) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />

      {/* Vignette coins */}
      <div className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.55) 100%)" }}
      />

      {/* ── Zone principale ── */}
      <div className="flex-1 min-h-0 relative p-4 pb-0">

        {/* Colonne gauche : explorateur + mes documents + icônes bureau */}
        <div className="absolute left-4 top-4 flex flex-col gap-0.5 w-52">

          {/* Explorateur — en premier, mis en valeur */}
          <button
            onClick={() => launchApp("explorer", { initialPath: "/Desktop" })}
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all text-left group w-full mb-1"
            style={{ background: "rgba(139,92,246,0.1)", border: "1px solid rgba(139,92,246,0.25)" }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(139,92,246,0.18)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(139,92,246,0.1)"; }}
          >
            <span className="text-2xl flex-shrink-0">📁</span>
            <div>
              <div className="text-[11px] font-semibold text-violet-200">Explorateur</div>
              <div className="text-[9px] text-violet-400/60 tracking-wide">Fichiers & preuves</div>
            </div>
          </button>

          {/* Mes documents — ouvre l'explorateur */}
          <button
            onClick={() => launchApp("documents", { initialPath: "/Documents" })}
            className="flex items-center gap-3 px-3 py-2 rounded-lg transition-all text-left group w-full mb-2"
            style={{ border: "1px solid transparent" }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = ""; e.currentTarget.style.borderColor = "transparent"; }}
          >
            <span className="text-2xl flex-shrink-0">🗂️</span>
            <span className="text-[11px] text-slate-300 group-hover:text-white transition-colors">Mes documents</span>
          </button>

          {/* Séparateur */}
          <div className="h-px bg-white/6 mx-3 mb-2" />

          {/* Icônes bureau */}
          {DESKTOP_ICONS.map((icon) => (
            <button
              key={icon.id}
              disabled={icon.disabled}
              onDoubleClick={() => !icon.disabled && launchApp(icon.id)}
              onClick={() => !icon.disabled && launchApp(icon.id)}
              className={[
                "flex items-center gap-3 px-3 py-2 rounded-lg transition-all w-full text-left group",
                icon.disabled ? "opacity-35 cursor-not-allowed" : "cursor-pointer",
              ].join(" ")}
              style={{ border: "1px solid transparent" }}
              onMouseEnter={(e) => { if (!icon.disabled) { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)"; } }}
              onMouseLeave={(e) => { e.currentTarget.style.background = ""; e.currentTarget.style.borderColor = "transparent"; }}
            >
              <span className="text-xl flex-shrink-0">{icon.emoji}</span>
              <span className="text-[11px] text-slate-400 truncate group-hover:text-slate-200 transition-colors">
                {icon.label}
              </span>
            </button>
          ))}
        </div>

        {/* Sticky notes — droite */}
        <div className="absolute right-4 top-4 flex flex-col gap-3 w-52">
          {STICKY_NOTES.map((note) => (
            <div key={note.id} className="rounded-lg p-3"
              style={{ background: note.color, border: `1px solid ${note.border}`, boxShadow: "0 2px 16px rgba(0,0,0,0.5)" }}>
              <div className="text-[9px] font-bold uppercase tracking-[0.18em] mb-1.5" style={{ color: note.labelColor }}>
                {note.label}
              </div>
              <p className="text-[11px] text-slate-300 leading-relaxed whitespace-pre-line">{note.text}</p>
            </div>
          ))}
        </div>

        {/* Widget central */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl p-5 text-center w-64"
          style={{ background: "rgba(0,0,0,0.4)", border: "1px solid rgba(239,68,68,0.12)", boxShadow: "0 0 40px rgba(0,0,0,0.6), 0 0 60px rgba(139,0,0,0.08)" }}>
          <div className="text-[10px] uppercase tracking-[0.2em] text-red-400/50 mb-1">Session active</div>
          <div className="text-2xl font-mono font-bold text-red-100/90 mb-1"><CLOCK /></div>
          <div className="text-[10px] text-red-300/40 mb-3">Philippe MARCHAND — PDG</div>
          <div className="h-px mb-3" style={{ background: "rgba(239,68,68,0.15)" }} />
          <div className="text-[10px] space-y-1">
            <div className="flex justify-between">
              <span className="text-slate-600">Dernière connexion</span>
              <span className="text-slate-400">14/02 — 08:47</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Niveau d'accès</span>
              <span style={{ color: "rgba(239,68,68,0.8)" }}>EXECUTIVE</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Statut réseau</span>
              <span className="text-emerald-400/70">● En ligne</span>
            </div>
          </div>
        </div>

        <div className="absolute left-4 bottom-3 text-[10px] text-slate-700 tracking-wide">
          Cliquez pour ouvrir
        </div>
      </div>

      {/* ── Barre des tâches ── */}
      <div className="flex-shrink-0 h-10 flex items-center justify-between px-4 border-t"
        style={{ background: "rgba(6,4,4,0.97)", borderColor: "rgba(239,68,68,0.1)", backdropFilter: "blur(8px)" }}>

        {/* Gauche */}
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 rounded flex items-center justify-center text-xs"
            style={{ background: "rgba(180,20,20,0.25)", border: "1px solid rgba(239,68,68,0.3)" }}>
            ⊞
          </div>
          <span className="text-[10px] text-red-400/50 tracking-[0.1em]">ORIGAMI OS — Bureau exécutif</span>
        </div>

        {/* Droite uniquement */}
        <div className="flex items-center gap-3">
          {usbEjected ? (
            <div className="flex items-center gap-1.5 text-[10px] text-emerald-400">
              <span>✅</span><span>Clé USB éjectée</span>
            </div>
          ) : (
            <div className="flex items-center gap-1.5 text-[10px] text-slate-600">
              <span>💾</span><span>Clé USB (E:) connectée</span>
            </div>
          )}
          <div className="text-[10px] font-mono text-red-400/40"><CLOCK /></div>
        </div>
      </div>

      {/* ── Fenêtre d'application ouverte ── */}
      {openApp && <AppWindow app={openApp} onClose={() => setOpenApp(null)} />}
    </div>
  );
}